const CountryFlag = ({ svgFlag, ...props }) => {
  const FlagComponent = svgFlag;
  return <FlagComponent style={{ width: '18px', height: '18px' }} {...props} />;
};

export default CountryFlag;
